import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { MapPin, ArrowLeft, Store } from 'lucide-react';

// Store data by city
const storesByCity = {
  nicosia: {
    name: 'Nicosia',
    nameGr: 'Λευκωσία',
    stores: [
      { id: 1, name: 'Cito Gourmet', category: 'Gourmet' },
      { id: 2, name: 'Marathassa Valley', category: 'Gourmet' },
      { id: 3, name: 'Mpaxari', category: 'Gourmet' },
      { id: 4, name: 'Prinos Farm & Deli', category: 'Gourmet' },
      { id: 5, name: 'Cava En Fiali Latsia', category: 'Cava' },
      { id: 6, name: 'Cava Sofokleous', category: 'Cava' },
      { id: 7, name: 'Cava Kyriakides', category: 'Cava' },
      { id: 8, name: 'Fiesta Del Vino', category: 'Cava' },
      { id: 9, name: 'Cava Perianos', category: 'Cava' },
      { id: 10, name: 'Cava Oinon Gefsis', category: 'Cava' },
      { id: 11, name: 'Cava Violaris', category: 'Cava' },
      { id: 12, name: 'Il Bacardo Vinoteca', category: 'Cava' },
      { id: 13, name: 'House of Spirits', category: 'Cava' },
      { id: 14, name: 'Mikropolis Paliometocho', category: 'Supermarket' },
      { id: 15, name: 'Mikropolis Nisou', category: 'Supermarket' },
      { id: 16, name: 'Mikropolis Athalassas', category: 'Supermarket' },
      { id: 17, name: 'Metro Platy', category: 'Supermarket' },
      { id: 18, name: 'Metro Aglantzia', category: 'Supermarket' },
      { id: 19, name: 'Metro Strovolos', category: 'Supermarket' },
      { id: 20, name: 'Alphamega Egkomi', category: 'Supermarket' },
      { id: 21, name: 'Alphamega Akropoli', category: 'Supermarket' },
      { id: 22, name: 'Alphamega Lakatamia', category: 'Supermarket' },
      { id: 23, name: 'MAS Agios Dometios', category: 'Supermarket' },
    ]
  },
  larnaca: {
    name: 'Larnaca',
    nameGr: 'Λάρνακα',
    stores: [
      { id: 1, name: 'Piece of cake By Athanasia', category: 'Gourmet' },
      { id: 2, name: 'The Art of Whiskey', category: 'Cava' },
      { id: 3, name: 'Spiritology', category: 'Cava' },
      { id: 4, name: 'Cavaway', category: 'Cava' },
      { id: 5, name: 'Metro Larnaca', category: 'Supermarket' },
      { id: 6, name: 'Alphamega Larnaca Central', category: 'Supermarket' },
    ]
  },
  limassol: {
    name: 'Limassol',
    nameGr: 'Λεμεσός',
    stores: [
      { id: 1, name: 'PUNIN Wines', category: 'Cava' },
      { id: 2, name: 'Viva Cava', category: 'Cava' },
      { id: 3, name: 'The Bottles Shop Germasogia', category: 'Cava' },
      { id: 4, name: 'The Bottles Shop Kolossi', category: 'Cava' },
      { id: 5, name: 'Cava Elite', category: 'Cava' },
      { id: 6, name: 'Cavaway', category: 'Cava' },
      { id: 7, name: 'Winecase', category: 'Cava' },
      { id: 8, name: 'Cava Protasis', category: 'Cava' },
      { id: 9, name: 'Saint Nektarios Cava', category: 'Cava' },
      { id: 10, name: 'Episkopi Espresso & Spirits', category: 'Cava' },
      { id: 11, name: 'Cava Pangeras', category: 'Cava' },
      { id: 12, name: 'Metro Mouttagiaka', category: 'Supermarket' },
      { id: 13, name: 'Metro Ayias Filaxeos', category: 'Supermarket' },
      { id: 14, name: 'Alphamega Linopetra', category: 'Supermarket' },
      { id: 15, name: 'Alphamega Kapsalos', category: 'Supermarket' },
      { id: 16, name: 'Alphamega Polemidia', category: 'Supermarket' },
    ]
  },
  paphos: {
    name: 'Paphos',
    nameGr: 'Πάφος',
    stores: [
      { id: 1, name: 'Labodega', category: 'Cava' },
      { id: 2, name: 'Crossroad Cava', category: 'Cava' },
      { id: 3, name: 'Cava Centro', category: 'Cava' },
      { id: 4, name: 'Live Cava', category: 'Cava' },
      { id: 5, name: 'Cava Presto', category: 'Cava' },
      { id: 6, name: 'Christakis C Michael Cava', category: 'Cava' },
      { id: 7, name: 'Alphamega Aphrodite', category: 'Supermarket' },
      { id: 8, name: 'Alphamega Paphos', category: 'Supermarket' },
      { id: 9, name: 'Alphamega Mandria', category: 'Supermarket' },
    ]
  },
  ammochostos: {
    name: 'Ammochostos',
    nameGr: 'Αμμόχωστος',
    stores: [
      { id: 1, name: 'Nicks Bottles Shop', category: 'Cava' },
      { id: 2, name: 'Cava Robustos', category: 'Cava' },
      { id: 3, name: 'Metro Paralimni', category: 'Supermarket' },
    ]
  }
};

export default function CityStores() {
  const { city } = useParams();
  const cityData = storesByCity[city];

  useEffect(() => {
    document.title = `Stores in ${cityData?.name || 'City'} - Salt & Stone`;
  }, [cityData]);

  if (!cityData) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-[#F2F0E9] text-2xl mb-4">City not found</h1>
          <Link to="/find" className="text-[#D4AF37] hover:underline">
            Back to regions
          </Link>
        </div>
      </div>
    );
  }

  // Group stores by category
  const storesByCategory = cityData.stores.reduce((acc, store) => {
    const category = store.category || 'Other';
    if (!acc[category]) acc[category] = [];
    acc[category].push(store);
    return acc;
  }, {});

  const categoryOrder = ['Gourmet', 'Cava', 'Supermarket', 'Other', ''];

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="city-stores-page">
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-start justify-center overflow-hidden bg-black pt-24">
        {/* Background */}
        <div className="absolute inset-0">
          <div className="lg:hidden absolute left-1/2 -translate-x-1/2 top-0 -translate-y-[40%] h-[95vh] w-[90vw]">
            <img
              src="https://customer-assets.emergentagent.com/job_60caa5be-1d50-4b72-801b-3659f641dade/artifacts/9uzc6zo8_IMG_7292.jpg"
              alt="Salt & Stone Gin Bottle"
              className="h-full w-full object-contain opacity-30"
            />
            <div className="absolute inset-0 pointer-events-none" style={{
              background: 'radial-gradient(ellipse 80% 70% at center 40%, transparent 45%, #000000 85%)'
            }}></div>
          </div>
          <img
            src="https://customer-assets.emergentagent.com/job_60caa5be-1d50-4b72-801b-3659f641dade/artifacts/9uzc6zo8_IMG_7292.jpg"
            alt="Salt & Stone Gin Bottle"
            className="hidden lg:block absolute right-0 top-1/2 -translate-y-1/2 h-full w-auto max-w-none object-contain opacity-50 translate-x-[20%]"
          />
          <div className="hidden lg:block absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/80 to-transparent"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/50 via-transparent to-[#050505]"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 w-full max-w-4xl mx-auto px-6 py-12">
          {/* Back Button */}
          <Link 
            to={`/find/${city}`}
            className="inline-flex items-center gap-2 text-[#D4AF37] hover:text-[#F2F0E9] transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </Link>

          {/* Header */}
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-3 mb-4">
              <MapPin className="w-6 h-6 text-[#D4AF37]" />
              <span className="caption">Find in Store</span>
            </div>
            <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl text-[#F2F0E9] mb-4">
              {cityData.name}
            </h1>
            <p className="text-[#F2F0E9]/60">
              {cityData.stores.length} retailer{cityData.stores.length !== 1 ? 's' : ''} available
            </p>
          </div>

          {/* Stores by Category */}
          <div className="space-y-10">
            {categoryOrder.map((category) => {
              const stores = storesByCategory[category];
              if (!stores || stores.length === 0) return null;
              
              return (
                <div key={category}>
                  {category && (
                    <h2 className="text-[#D4AF37] text-sm uppercase tracking-widest mb-4 border-b border-[#D4AF37]/20 pb-2">
                      {category}
                    </h2>
                  )}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {stores.map((store) => (
                      <div 
                        key={store.id}
                        className="border border-white/10 bg-black/40 backdrop-blur-sm p-4 hover:border-[#D4AF37]/30 transition-colors flex items-center gap-4"
                      >
                        <div className="w-10 h-10 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                          <Store className="w-5 h-5 text-[#D4AF37]" />
                        </div>
                        <span className="text-[#F2F0E9]">{store.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Contact note */}
          <div className="mt-12 text-center border-t border-white/10 pt-8">
            <p className="text-[#F2F0E9]/40 text-sm italic">
              Want to become a stockist? Contact us.
            </p>
            <Link 
              to="/contact" 
              className="inline-block mt-4 text-[#D4AF37] text-sm hover:underline"
            >
              Get in Touch
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
